/**
 * Model to hold a single organizationBoutAttribute mapping.
 */
export class OrganizationBoutAttribute {
    public id: string;
    public identityOrganizationId: string;
    public boutAttributeName: string;

    public clone(): OrganizationBoutAttribute {
        const clone: OrganizationBoutAttribute = new OrganizationBoutAttribute();
        clone.id = this.id;
        clone.identityOrganizationId = this.identityOrganizationId;
        clone.boutAttributeName = this.boutAttributeName;
        return clone;
    }

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: any): OrganizationBoutAttribute {
        const data: any = json['data'] || json;
        const attrs: any = data['attributes'] || {};

        this.id = data.id;
        this.identityOrganizationId = attrs.identityOrganizationId;
        this.boutAttributeName = attrs.boutAttributeName;

        return this;
    }
}
